<div class="datatable-super-upper-wrap">
  <div class="searchbar-wrapper" *ngIf="enableSearch || showColumnConfig || showToolbarActions">
    <div class="search-group" *ngIf="enableSearch">
      <div class="input-wrap">
        <i class="fas fa-search search-icon" aria-hidden="true"></i>
        <input
          class="mat-input-element search-input"
          matInput
          name="searchtext"
          type="text"
          [placeholder]="placeholder"
          [(ngModel)]="searchText"
          (keyup.enter)="searcher(searchText)"
        />
      </div>
      <button
        class="btn btn-primary submit-button search-button"
        (click)="searcher(searchText)"
        [disabled]="disabled"
        #searchButton
      >
        {{ buttonTitle }}
      </button>
    </div>
    <span class="dt-actions-slot"><ng-content select="[dtToolbarActions]"></ng-content></span>
    <div class="configure-columns-wrapper config-standalone" *ngIf="showColumnConfig">
      <div class="configure-columns-wrapper">
        <!-- Was an <img> pointing at https://4comply.io/images/TableSettingsIcon.png. That host
             now answers 302 with text/html, so every table in the app rendered a broken image:
             the control depended on an external site staying unchanged. fa-table-columns is the
             columns glyph in the Font Awesome the app already loads. -->
        <div
          class="tooltip tooltip-bottom edit-columns-wrapper"
          role="button"
          tabindex="0"
          [attr.aria-label]="'TABLE.CONFIGURE_COLUMNS' | translate"
          [attr.data-tooltip]="'TABLE.CONFIGURE_COLUMNS' | translate"
          (click)="toggleColumnSettings()"
          (keydown.enter)="toggleColumnSettings()"
          (keydown.space)="toggleColumnSettings()">
          <i class="fas fa-table-columns edit-columns-icon" aria-hidden="true"></i>
        </div>
        <div class="column-settings-wrapper col-filter" *ngIf="showColumnSettings">
          <!-- header -->
          <div class="cf-head">
            <span class="cf-title">{{ 'TABLE.COLUMNS' | translate }}</span>
            <button
              type="button"
              class="cf-close"
              [attr.aria-label]="'GENERIC.CLOSE' | translate"
              (click)="toggleColumnSettings()"
            >×</button>
          </div>

          <!-- show all -->
          <button type="button" class="cf-showall" (click)="toggleAllColumns()">
            <span class="cf-box" [class.checked]="allColumnsVisible">
              <i *ngIf="allColumnsVisible" class="fas fa-check"></i>
            </span>
            <span class="cf-showall-label">{{ 'TABLE.SHOW_ALL_COLUMNS' | translate }}</span>
          </button>

          <!-- column list -->
          <div class="cf-list" cdkDropList (cdkDropListDropped)="drop($event)">
            <div class="cf-row" *ngFor="let col of columnMapping; let i = index" cdkDrag>
              <span
                class="cf-grip"
                cdkDragHandle
                [title]="'TABLE.DRAG_TO_REORDER' | translate"
              >
                <i class="fas fa-grip-vertical"></i>
              </span>
              <button type="button" class="cf-toggle" (click)="toggleColumn(col)">
                <span class="cf-box" [class.checked]="!col.disabled">
                  <i *ngIf="!col.disabled" class="fas fa-check"></i>
                </span>
                <span class="cf-label" [class.muted]="col.disabled">{{ col.name | translate }}</span>
              </button>
              <div class="cf-arrows">
                <button
                  type="button"
                  class="cf-arrow"
                  [disabled]="i === 0"
                  [title]="'GENERIC.UP' | translate"
                  (click)="moveColumn(i, -1)"
                ><i class="fas fa-chevron-up"></i></button>
                <button
                  type="button"
                  class="cf-arrow"
                  [disabled]="i === columnMapping.length - 1"
                  [title]="'GENERIC.DOWN' | translate"
                  (click)="moveColumn(i, 1)"
                ><i class="fas fa-chevron-down"></i></button>
              </div>
            </div>
          </div>

          <!-- footer -->
          <div class="cf-foot">
            <button type="button" class="cf-reset" (click)="resetColumns()">
              {{ 'TABLE.RESET' | translate }}
            </button>
            <button type="button" class="cf-done" (click)="toggleColumnSettings()">
              {{ 'GENERIC.DONE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="datatable-upper-wrap">
    <ngx-datatable
      class="material striped custom-ngx-dt"
      [rows]="rows"
      [loadingIndicator]="loadingIndicator"
      [columnMode]="ColumnMode.force"
      [headerHeight]="40"
      [footerHeight]="footerHeight"
      [rowHeight]="'auto'"
      [messages]="{ emptyMessage: 'TABLE.NO_DATA' | translate }"
      [externalSorting]="enableExternalSorting"
      [scrollbarH]="scrollbarH"
      [sorts]="sorts"
      (sort)="onSort($event)"
    >
      <!-- [scrollbarV]="false"  [scrollbarH]="true"-->
      <ng-container *ngIf="!enableExternalSorting">
        <ngx-datatable-column
          *ngFor="let col of renderedColumnList"
          [prop]="col.prop"
          [name]="col.name | translate"
          [width]="col.width"
          [maxWidth]="col.maxWidth"
          [sortable]="col.sortable"
        >
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <div *ngIf="col.prop !== 'actions' && col.prop !== 'customFields'">
              <mat-form-field *ngIf="isEditable[rowIndex]">
                <input matInput [(ngModel)]="row[col.prop]" />
              </mat-form-field>
              <span
                *ngIf="
                  !isEditable[rowIndex] &&
                  col.type !== 'link' &&
                  col.type !== 'localLink' &&
                  col.type !== 'translate'
                "
                >{{ value || "-" }}</span
              >
              <span *ngIf="col.type === 'translate'">{{
                value || "-" | translate
              }}</span>
              <a
                [href]="value"
                target="_blank"
                *ngIf="!isEditable[rowIndex] && col.type === 'link'"
                >{{ value }}</a
              >
              <a
                [routerLink]="row.linkValue"
                *ngIf="!isEditable[rowIndex] && col.type === 'localLink'"
                >{{ value }}</a
              >
            </div>
            <div class="action-list-custom" *ngIf="col.prop === 'customFields'">
              <div class="action-item">
                <button (click)="onCustomFields(row)" class="btn btn-primary">
                  {{ "GENERIC.VIEW_FIELDS" | translate }}
                </button>
              </div>
            </div>
            <div class="action-list-custom" *ngIf="col.prop === 'actions'">
              <ng-container *ngFor="let a of actions">
                <div class="action-item" *ngIf="shouldShowAction(a)">
                  <div [ngSwitch]="a.toolTipText">
                    <div *ngSwitchCase="'GENERIC.EDIT'" class="action-buttons">
                      <button
                        (click)="onEditClick(a, row, rowIndex)"
                        class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                        [attr.data-tooltip]="a.toolTipText | translate"
                        *ngIf="!isEditable[rowIndex]"
                      >
                        <i class="{{ a.iconClass }}"></i>
                      </button>

                      <button
                        (click)="saveData(row, rowIndex)"
                        class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left save-button"
                        [attr.data-tooltip]="'GENERIC.SAVE' | translate"
                        *ngIf="isEditable[rowIndex]"
                      >
                        <i class="fas fa-check"></i>
                      </button>
                      <button
                        (click)="onCancelEdit(rowIndex)"
                        class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                        [attr.data-tooltip]="'GENERIC.CANCEL' | translate"
                        *ngIf="isEditable[rowIndex]"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>

                    <button
                      *ngSwitchDefault
                      (click)="onActionClick(a, row.id)"
                      class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                      [attr.data-tooltip]="a.toolTipText | translate"
                    >
                      <i class="{{ a.iconClass }}"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ng-container>

      <ng-container *ngIf="!!enableExternalSorting">
        <ngx-datatable-column
          *ngFor="let col of renderedColumnList"
          [prop]="col.prop"
          [comparator]="noopComparator"
          [name]="col.name | translate"
          [width]="col.width"
          [maxWidth]="col.maxWidth"
        >
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <div *ngIf="col.prop !== 'actions' && col.prop !== 'customFields'">
              <mat-form-field *ngIf="isEditable[rowIndex]">
                <input matInput [(ngModel)]="row[col.prop]" />
              </mat-form-field>
              <span
                *ngIf="
                  !isEditable[rowIndex] &&
                  col.type !== 'link' &&
                  col.type !== 'localLink' &&
                  col.type !== 'translate'
                "
                >{{ value || "-" }}</span
              >
              <span *ngIf="col.type === 'translate'">{{
                value || "-" | translate
              }}</span>
              <a
                [href]="value"
                target="_blank"
                *ngIf="!isEditable[rowIndex] && col.type === 'link'"
                >{{ value }}</a
              >
              <a
                [routerLink]="row.linkValue"
                *ngIf="!isEditable[rowIndex] && col.type === 'localLink'"
                >{{ value }}</a
              >
            </div>
            <div class="action-list-custom" *ngIf="col.prop === 'customFields'">
              <div class="action-item">
                <button (click)="onCustomFields(row)" class="btn btn-primary">
                  {{ "GENERIC.VIEW_FIELDS" | translate }}
                </button>
              </div>
            </div>
            <div class="action-list-custom" *ngIf="col.prop === 'actions'">
              <ng-container *ngFor="let a of actions">
                <div class="action-item" *ngIf="shouldShowAction(a)">
                  <div [ngSwitch]="a.toolTipText">
                    <div *ngSwitchCase="'GENERIC.EDIT'"
                         class="action-buttons-wrapper">
                      <button
                        (click)="onEditClick(a, row, rowIndex)"
                        class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                        [attr.data-tooltip]="a.toolTipText | translate"
                        *ngIf="!isEditable[rowIndex]"
                      >
                        <i class="{{ a.iconClass }}"></i>
                      </button>

                      <button
                        *ngIf="isEditable[rowIndex]"
                        class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left save-button"
                        [attr.data-tooltip]="'GENERIC.SAVE' | translate"
                        (click)="saveData(row, rowIndex)"
                      >
                        <i class="fas fa-check"></i>
                      </button>
                      <button
                        (click)="onCancelEdit(rowIndex)"
                        class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                        [attr.data-tooltip]="'GENERIC.CANCEL' | translate"
                        *ngIf="isEditable[rowIndex]"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>

                    <button
                      *ngSwitchDefault
                      (click)="onActionClick(a, row.id)"
                      class="btn btn-action btn-primary btn-sm s-circle tooltip tooltip-left"
                      [attr.data-tooltip]="a.toolTipText | translate"
                    >
                      <i class="{{ a.iconClass }}"></i>
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ng-container>
    </ngx-datatable>
  </div>
</div>
